import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class RepAssessment extends Mappeable {

    idValorationPk: number;
    txtName: string;
    order: 0
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
        this.order = this.order ??  0 
    }

    public mapToBack() {
        return {
            txtName: this.txtName,
            order: this.order,
            value: this.order,
            mrkActive: this.mrkActive,
        }
    }


}
